import { ReactNode } from 'react';
import { P2GGrid, P2GText } from '@parcel2go/core-ui';

interface Props {
  title: string;
  children: ReactNode;
  className?: string;
}

export const ContentBlock = ({ title, children, className }: Props): JSX.Element => {
  return (
    <P2GGrid classNames={className} py={1}>
      {title && <P2GText variant="subtitle2">{title}</P2GText>}
      <P2GGrid pt={1}>{children}</P2GGrid>
    </P2GGrid>
  );
};
